<template>
  <a
    :class="{ active: expanded }"
    role="menuitem"
    :aria-expanded="expanded.toString()"
    @mouseenter="expand"
    @mouseleave="mouseOut"
  >
    <slot />
  </a>
</template>

<script>
import eventBus from '@/js/util/eventBus'

export default {
  data() {
    return {
      expanded: false,
    }
  },
  props: {
    section: {
      type: String,
    },
    type: {
      type: String,
    },
  },
  computed: {
    isToggle: function() {
      return this.type == 'toggle'
    },
  },
  methods: {
    sectionExpand(expand) {
      // close other expanded links
      if (!this.expanded) {
        eventBus.$emit('nav:desktop:collapse')
      }
      this.expanded = expand
      eventBus.$emit('nav:desktop:opened', true)
      eventBus.$emit('nav:desktop:' + this.section, this.expanded)
    },
    // if expanded, manipulate tab forward and backward to be inside the dropdown
    handleTabKey(event) {
      if (this.expanded && event.key === 'Tab') {
        event.preventDefault()
        if (event.shiftKey) {
          event.stopPropagation()
          eventBus.$emit('select:menu:last')
        } else {
          eventBus.$emit('select:menu:first')
        }
      }
    },
    collapseSection(type) {
      if (this.expanded) {
        this.expanded = false
        eventBus.$emit('nav:desktop:' + this.section, this.expanded)
      }
      if (type == 'single') {
        this.$el.focus()
      }
    },
    getFocus() {
      this.$el.focus()
    },
    closeMenu(param) {
      if (param && this.expanded) {
        this.expanded = false
        eventBus.$emit('nav:desktop:' + this.section, this.expanded)
      }
    },
    updateExpanded(expand) {
      this.expanded = expand
    },
    expand() {
      this.$parent.mouseIsOver = true
      this.$emit('expand', true)
    },

    mouseOut() {
      this.$parent.mouseIsOver = false
    },
  },
  mounted() {
    eventBus.$on('nav:desktop:collapse', this.collapseSection)
    eventBus.$on(
      'nav:desktop:' + this.section + ':collapse',
      this.collapseSection
    )
    eventBus.$on('nav:desktop:' + this.section + ':focus', this.getFocus)
    eventBus.$on('nav:search', this.closeMenu)
    eventBus.$on('nav:desktop:' + this.section + ':update', this.updateExpanded)
  },
}
</script>
